import { connect } from 'react-redux'
import { currentRole } from '#/store/selectors/user'
import WFG from './WFG'

const mapStateToProps = (state: TopHap.StoreState) => ({
  authenticated: state.user.info.isAnonymous === false,
  currentRole: currentRole(state),
  isMobile: state.global.isMobile.any,
  asyncStatus: state.global.status
})

const mapDispatchToProps = {}

export default connect(mapStateToProps, mapDispatchToProps)(WFG)
